const getLanguage = (language: any[], locale: string | undefined) => {
  if (!Array.isArray(language) || language.length === 0) return undefined;

  const normalizedLocale = locale?.toLowerCase();
  const matched = language.find(item => item.locale?.toLowerCase() === normalizedLocale);
  if (matched) return matched;

  const defaultLocale = language.find(item => item.locale?.toLowerCase() === "pl");
  return defaultLocale ?? language[0];
};

export default getLanguage;
  